/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Modal, Box, Grid, Tooltip, Select, MenuItem, Button } from '@mui/material';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import Notification from '../../shared/notification-modal';
import { defaultUnitValues, defaultModalOptions } from '../../shared/constantVariable';
import { checkFileExists, saveWinflowsFileContent, getWinflowsFileContent_units } from '../../shared/api/url-helper';

import { encrypt_data, decrypt_data } from '../../shared/utils';
import { getEmailUserType, checkLocalStorageValue } from '../../shared/helper';

// Exportable helper to persist Region and unit settings without UI state dependencies
export const Location_Save = (Location) => {
  try {
    const response_final = JSON.parse(localStorage.getItem('default_unit_set_dict')) || {
      'Volume Flow': defaultUnitValues.flow,
      'Pressure': defaultUnitValues.pressure,
      'Temperature': defaultUnitValues.temp,
      'Liquid Volume': defaultUnitValues.volume,
      'Flux': defaultUnitValues.flux,
      'Power': defaultUnitValues.power,
      'type': defaultUnitValues.type
    };
    const userMailId = sessionStorage.getItem('user_email');
    // Preserve existing Region if not updating, or use new Location value
    const payload_units = { ...response_final, 'Region': Location };
    const encrypt_units = encrypt_data(payload_units);

    return saveWinflowsFileContent(`units/${userMailId}`, userMailId, getEmailUserType(userMailId), encrypt_units)
      .then(() => {
        localStorage.setItem('default_unit_set_dict', JSON.stringify(payload_units));
        localStorage.setItem('unit_set_dict', JSON.stringify(payload_units));
        localStorage.setItem('system-units', JSON.stringify({
          temp: payload_units.Temperature,
          pressure: payload_units.Pressure,
          flow: payload_units['Volume Flow'],
          flux: payload_units.Flux,
          power: payload_units.Power,
          volume: payload_units['Liquid Volume'],
        }));
      })
      .catch((err) => {
        console.error('Failed to save Region/units', err);
      });
  } catch (e) {
    console.error('Unexpected error in Location_Save', e);
    return Promise.resolve();
  }
};

function RegionSelection(props) {
  const { visibleRegionSelection, handleCloseRegionSelection, translateObject } = props;

  const [selectedRegion, setSelectedRegion] = useState([]);
  const [Regionval, setRegionval] = useState('');
  // notification modal
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const t = translateObject;
  const closeModelOptionwithRegionModel = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: false,
    });
    handleCloseRegionSelection(true);
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => closeModelOptionwithRegionModel(),
      type
    });
  };
  const Regions = [
    { value: 'ANZ', label: 'Australia and New Zealand (ANZ)' },
    { value: 'SEA', label: 'Southeast Asia (SEA)' },
    { value: 'GRC', label: 'Greater China (GRC)' },
    { value: 'EMEA', label: 'Europe, Middle East, and Africa (EMEA)' },
    { value: 'NAM', label: 'North America (NAM)' },
    { value: 'LAM', label: 'Latin America (LAM)' },
    // { value: 'PA_team', label: 'Pacific Asia Team' }
  ];
  // Component-scoped wrapper to show modal feedback after saving
  const handleLocationSaveWithUI = (Location) => {
    return Location_Save(Location)
      .then(() => {
        openModelPopUp(translateObject('Region has been saved successfully.'), 'Success!', 'success');
      })
      .catch(() => {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          type: 'error',
          title: 'Error',
          message: translateObject('Failed to load Default units.'),
          yesOrNo: false,
        });
        throw new Error('save failed');
      });
  };
  const handleChange = (e, str) => {
    const { value } = e.target;
    if (str === 'Region') {
      setRegionval(value);
    }
  };
  useEffect(() => {
    const data = Regions.map((ele) => {
      return { value: ele.value, label: ele.label };
    });
    setSelectedRegion(data);
  }, []);

  const handleCloseSplitModal = () => { handleCloseRegionSelection(); };
  const handleUpdate = async() => {
    sessionStorage.setItem('Region', Regionval);
    await handleLocationSaveWithUI(Regionval);
    // handleCloseRegionSelection is commented out because we display a success/error popup after saving.
    // The popup handler manages the modal closure - when the user closes the notification popup,
    // handleCloseRegionSelection is triggered via closeModelOptionwithRegionModel() callback.
  };
  return (
    <Modal
      hideBackdrop
      open={visibleRegionSelection}
      onClose={handleCloseRegionSelection}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="argoComp-modal"
    >
      <Box className=''>
        <Notification options={modalOption} handleClose={() => closeModelOptionwithRegionModel()} />
        <Rnd
          default={{
            width: '25%',
            x: ((window.innerWidth / 2) - ((25 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((50 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='20%'
          cancel=".ro-table-grid"
          onDragStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className='argoComp-box'>
          <Grid container className='argoComp-grid-container'>
            <Grid item xs={12}>
              <Grid item xs={12} className='model_header'>
                <div className='model_header_text S_heading'>{translateObject('Region Selection')}</div>
                <div className='argoComp-close-icon'>
                  <Tooltip title="Close">
                    <img
                      src={closeIconBlack}
                      alt="close"
                      onClick={handleCloseSplitModal}
                      style={{ width: '14px', padding: '11px' }}
                      className="pointer"
                    />
                  </Tooltip>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ 'padding': '0.5rem' }}>
              <div className="normal-font no_drag S_Bold">{translateObject('Select Region')}</div>
              <div className='select-dropdown-argo mt-2 no_drag'>
                <Select
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  value={Regionval}
                  name='waterSource'
                  fullWidth
                  onChange={(e) => { handleChange(e, 'Region'); }}
                  data-testid='waterSource'>
                  {(selectedRegion || []).map((ele) => (
                    <MenuItem key={ele.label}
                      value={ele.value}>{ele.label}</MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid className='splitter-mixer-update-button' item xs={12}>
              <div className='note-item'>
                <Grid container className='Argo-note-text sansW4SeLig M_Regular'>
                  <Grid item xs={12} className='no_drag S_Bold Note'>{translateObject('Note')}</Grid>
                  <Grid item xs={12} className='no_drag S_Regular primary_text'>{translateObject('Please select your Region from the list given.')}</Grid>
                  <Grid item xs={12} className='no_drag S_Regular primary_text'>{translateObject('This selection allows Winflows to provide you with region-specific MemChem options.')}</Grid>
                  <Grid item xs={12} className='no_drag S_Regular primary_text'>{translateObject('Important: Your Region selection is permanent and cannot be changed after submission.')}</Grid>
                </Grid>
              </div>
              <Grid container spacing={2}>
                <Grid item xs={6} md={12} sm={12}>
                  <div className="Argo-button">
                    <div className='cancel-ok-button'>
                      <Button variant="contained" className="sansW4SeLig M_Bold Secondary-Default_button"
                        size="small" style={{ width: '120px', marginRight: '15px' }} onClick={handleCloseSplitModal}> {translateObject('Cancel')} </Button>
                      <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button"
                        size="small" style={{ width: '120px' }} onClick={handleUpdate}> {translateObject('OK')} </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
}

export default RegionSelection;
